<pf-content>
    <form [formGroup]="data.formGroup">
        <p>
            {{ exceptionDescription() }}
        </p>
        <section pfSection pfTitle="Reason">
            @if (!data.staticReason) {
                <pf-select
                    #reasonSelect
                    [data]="exceptionOptions"
                    [selectedOption]="initialReasonOption()"
                    controlName="reason"
                    [pfDisabled]="saving()"
                    (selected)="onReasonSelected($event)"></pf-select>
            } @else {
                <p>{{ (data.reason | async)?.label || "" }}</p>
            }
        </section>

        <section pfSection pfTitle="Pictures">
            <div class="pictures-container">
                <nz-upload
                    nzType="drag"
                    [nzMultiple]="true"
                    [nzBeforeUpload]="beforeUploadFn"
                    [nzFileList]="fileList()"
                    nzListType="picture-card"
                    [nzAccept]="fileInputAccept"
                    [nzDisabled]="fileList().length >= 3 || saving()"
                    (nzFileListChange)="onFileListChange($event)">
                    <p class="ant-upload-drag-icon">
                        <span nz-icon nzType="inbox"></span>
                    </p>
                    <p class="ant-upload-text">Tap to add picture</p>
                </nz-upload>
            </div>
        </section>

        <section pfSection pfTitle="Notes">
            <pf-input
                inputType="textarea"
                controlName="notes"
                [pfDisabled]="saving()"></pf-input>
        </section>

        @if (data.additionalContent) {
            <section pfSection pfTitle="Additional" class="additional-info">
                <ng-container
                    *ngComponentOutlet="data.additionalContent"></ng-container>
            </section>
        }

        <pf-button
            class="confirm-button"
            [disabled]="data.formGroup.invalid"
            (click)="confirm()"
            [loading]="saving()"
            buttonType="submit"
            block
            >Confirm
        </pf-button>
    </form>
</pf-content>
